import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { featureFlagsResolver } from '@core/resolvers/feature-flags.resolver';
import { AuthModule } from './auth.module';
import { BbidNewUserComponent } from './bbid-new-user/bbid-new-user.component';
import { BbidSigninComponent } from './bbid-signin/bbid-signin.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginTabsWrapperComponent } from './login-tabs-wrapper/login-tabs-wrapper.component';
import { VerificationCodePageComponent } from './verification-code-page/verification-code-page.component';

@NgModule({
  imports: [
    AuthModule,
    RouterModule.forChild([{
      path: '',
      component: LoginTabsWrapperComponent,
      resolve: {
        featureFlags: featureFlagsResolver
      },
      children: [{
        path: 'signin',
        component: LoginFormComponent
      }, {
        path: 'bbid-signin',
        component: BbidSigninComponent
      }, {
        path: 'bbid-new-user',
        component: BbidNewUserComponent
      }, {
        path: 'verification-code',
        component: VerificationCodePageComponent
      }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'signin'
      }, 
      // Support for outdated routes, so that they redirect the user to signin
      {
        path: 'reset-password',
        pathMatch: 'full',
        redirectTo: 'signin'
      }, {
        path: 'signup',
        pathMatch: 'full',
        redirectTo: 'signin'
      }, {
        path: 'confirm-email',
        pathMatch: 'full',
        redirectTo: 'signin'
      }]
    }])
  ]
})
export class ApplicantAuthModule { }
